module.exports = __webpack_public_path__ + "static/media/1.1ccb9b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/1.png
// module id = 968
// module chunks = 0